import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../../services/tokens.service";

//export const dominiosSegurify = [""inter.mx", "interify.mx", "pentafon.com",   "prudential.com", 
// "everhealth.mx","masservicios.com.mx","gabssa.mx","dentalfirst.com.mx""]
export const dominiosSegurify = [];

async function cargarDominios() {
  try {
    const config = {
      headers: {
        Authorization: "Bearer " + getAgenteAccessToken()
      }
    };
    const response = await mainAxios.get(
      "/v1/catalogo/dominios-usuarios-rol",
      config
    );
    const lista = response.data.map(item => item.dominio);
    dominiosSegurify.push(...lista);
  } catch (e) {
    console.error("No se pudieron cargar dominios:", e);
  }
}

cargarDominios();

export const validarDominioSegurify = (correo) => {
  if (!correo) return true;
  const dominio = correo.split("@")[1];

  if (!dominiosSegurify.find((d) => d === dominio))
    return "Dominio no permitido";

  return true;
};

export default validarDominioSegurify;
